import { supabase } from "./supabaseClient";

export async function submitResponse(responseId, submissionText = "", violations = []) {
  const comments = {
    violations,
    totalTimeOutSeconds: violations
      .filter(v => v.endTime !== null)
      .reduce((acc, v) => acc + (v.endTime - v.startTime), 0) / 1000,
  };

  const { data, error } = await supabase.rpc("submit_response", {
    p_response_id: responseId,
    p_submission: submissionText,     // ← restore from the hardcoded "" back to the real arg
    p_comments: comments,
  });

  if (error) {
    if (error.message.includes("ALREADY_SUBMITTED"))
      return { success: false, msg: "Already submitted." };
    if (error.message.includes("TIME_OVER"))
      return { success: false, msg: "Time is over, can no longer submit." };
    if (error.message.includes("RESPONSE_NOT_FOUND"))
      return { success: false, msg: "Response not found." };
    return { success: false, msg: error.message };
  }
  return { success: true };
}

export async function createResponse(rollId, userInfo, questionId) {
  const { data, error } = await supabase.rpc("create_response", {
    p_rollid: rollId,
    p_user_info: userInfo,
    p_question_id: questionId,
  });

  if (error) {
    if (error.message.includes("RESPONSE_ALREADY_EXISTS")) {
      return { success: false, msg: "You have already submitted a response for this test." };
    }
    return { success: false, msg: error.message };
  }

  return { success: true, id: data };
}

